import { LanguageDropdown } from '@ghq-abi/design-system';
import { useTolgee } from '@tolgee/react';
import { usePutEmployeeLanguage } from '~/entities/Employee/api/usePutEmployeeLanguage';
import { useUser } from '~/shared/auth/useUser';
import { I18n } from '~/shared/components/icons';
import { REGISTERED_LANGUAGES } from '~/shared/constants/i18n';
import { persistLanguage } from '~/shared/utils/languagePersistence';

const LANGUAGE_NAMES: Record<string, string> = {
  'de-DE': 'Deutsch',
  'en-US': 'English',
  es: 'Español',
  'fr-CA': 'Français (Canada)',
  'fr-FR': 'Français',
  'it-IT': 'Italiano',
  'ja-JP': '日本語',
  'ko-KR': '한국어',
  'nl-NL': 'Nederlands',
  'pt-BR': 'Português',
  'ru-RU': 'Русский',
  sw: 'Swahili',
  'uk-UA': 'Українська',
  'vi-VN': 'Tiếng Việt',
  'zh-CN': '中文',
};

export function LanguageSelector() {
  const tolgee = useTolgee();
  const lang = tolgee.getLanguage();
  const user = useUser();

  const putEmployeeLanguageMutation = usePutEmployeeLanguage();

  const handleLanguageChange = (code: string) => {
    persistLanguage(code);
    tolgee.changeLanguage(code);

    if (user.employeeId) {
      putEmployeeLanguageMutation.mutate({
        employeeId: user.employeeId,
        preferredLanguage: code,
      });
    }
  };

  const items = REGISTERED_LANGUAGES.map(code => ({
    label: LANGUAGE_NAMES[code] || code,
    onSelect: () => handleLanguageChange(code),
  }));

  if (items.length <= 1) {
    return null;
  }

  const currentLang = lang || REGISTERED_LANGUAGES[0];
  const selectedValue = LANGUAGE_NAMES[currentLang] || currentLang;

  return (
    <LanguageDropdown
      items={items}
      value={selectedValue}
      aria-label="Select language"
    >
      <I18n />
    </LanguageDropdown>
  );
}
